import React from "react";
import { ChevronRight, Clock3, Mail, MessageCircle, Phone, ShieldCheck, Users } from "lucide-react";
import { CONTACT, mailLink, telLink, waLink } from "@/config";

interface CtaBandProps {
  eyebrow?: string;
  title: string;
  desc: string;
  variant?: "buttons" | "whatsapp";
}

const EmphasisedTitle = ({ title }: { title: string }) => {
  const words = title.trim().split(/\s+/);
  const accent = words.pop();
  return <>{words.join(" ")} {accent && <span>{accent}</span>}</>;
};

export const CtaBand: React.FC<CtaBandProps> = ({
  eyebrow = "Let's talk about your next car",
  title,
  desc,
  variant = "buttons",
}) => {
  const links = variant === "whatsapp" ? [
    { href: waLink(), label: "WhatsApp", detail: "Chat with me", icon: MessageCircle, className: "contact-band-link--whatsapp", testId: "cta-whatsapp-single", external: false },
  ] : [
    { href: telLink, label: "Call Now", detail: CONTACT.phone, icon: Phone, className: "contact-band-link--call", testId: "cta-call", external: false },
    { href: waLink(), label: "WhatsApp", detail: "Chat with me", icon: MessageCircle, className: "contact-band-link--whatsapp", testId: "cta-whatsapp", external: false },
    { href: mailLink(), label: "Email Me", detail: CONTACT.email, icon: Mail, className: "contact-band-link--email", testId: "cta-email", external: false },
  ];

  return (
    <section className="contact-band-wrap">
      <div className="container-x">
        <div className="contact-band">
          <div className="contact-band-art" aria-hidden="true"><i /><i /><span>TOYOTA</span></div>

          <div className="contact-band-copy">
            <p className="contact-band-eyebrow"><span aria-hidden="true" />{eyebrow}</p>
            <h3><EmphasisedTitle title={title} /></h3>
            <p className="contact-band-description">{desc}</p>
          </div>

          <div className="contact-band-contact">
            <p className="contact-band-script" aria-hidden="true">Here to help</p>
            <div className={`contact-band-links contact-band-links--${variant}`}>
              {links.map(({ icon: Icon, external, ...link }) => (
                <a key={link.label} href={link.href} target={external ? "_blank" : undefined} rel={external ? "noreferrer" : undefined} data-testid={link.testId} className={`contact-band-link ${link.className}`}>
                  <span className="contact-band-link-icon"><Icon /></span>
                  <span className="contact-band-link-copy"><strong>{link.label}</strong><small>{link.detail}</small></span>
                  <ChevronRight className="contact-band-chevron" />
                </a>
              ))}
            </div>
          </div>

          <div className="contact-band-trust">
            <div><ShieldCheck /><span><strong>Friendly Support</strong><small>Here to help</small></span></div>
            <div><Clock3 /><span><strong>Quick Response</strong><small>Usually within minutes</small></span></div>
            <div><Users /><span><strong>Your Trusted Consultant</strong><small>A smoother car buying journey</small></span></div>
          </div>

          <p className="contact-band-signoff"><span aria-hidden="true" />Driven by people<br />for a brighter tomorrow</p>
        </div>
      </div>
    </section>
  );
};

export default CtaBand;
